// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"94":"57e5b827","173":"cea2b83a","740":"4a55d13b"}[chunkId] + ".css";
};